import React from 'react'

import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useArchiveDocumentImageMutation } from '../hooks/useArchiveDocumentImageMutation'
import { useInvalidateDocumentImagesInfiniteQuery } from '../hooks/useDocumentImagesInfiniteQuery'
import { type DocumentImage } from '../hooks/useFetchDocumentImages'

export type ArchiveButtonProps = {
  documentImage: DocumentImage
}

export const ArchiveButton = ({ documentImage }: ArchiveButtonProps) => {
  const invalidateDocumentImagesInfiniteQuery =
    useInvalidateDocumentImagesInfiniteQuery()
  const archiveDocumentImageMutation = useArchiveDocumentImageMutation({
    onSuccess: () => {
      invalidateDocumentImagesInfiniteQuery()
    },
  })

  const logEvent = useLogEvent()
  const handleClick = React.useCallback<EH<IconButtonProps, 'onClick'>>(
    (event) => {
      event.stopPropagation()
      archiveDocumentImageMutation.mutate(documentImage.id)
      logEvent('Put table and graph into trash')
    },
    [archiveDocumentImageMutation, documentImage.id, logEvent],
  )

  return (
    <IconButton
      disabled={archiveDocumentImageMutation.isPending}
      fillMode="outline"
      icon="delete"
      onClick={handleClick}
    />
  )
}
